import * as React from "react";

function SvgPaycellWithoutLabel(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.634.401l.336.072.01.006C34.615 2.861 41.334 13.528 38.991 24.31 36.643 35.092 26.12 41.904 15.484 39.527a19.457 19.457 0 01-1.74-.476l-.569-.195 2.497-12.186c.63.392 1.31.692 2.023.89 4.118 1.136 8.366-1.326 9.489-5.5 1.121-4.175-1.307-8.481-5.425-9.62-4.117-1.138-8.365 1.32-9.49 5.492l-.023.093-.022.091-.05.25-3.745 18.021C1.89 31.755-1.253 23.587.463 15.69 2.786 5.022 13.113-1.76 23.634.401zm-3.277 17.093c1.345.377 2.138 1.785 1.776 3.151-.372 1.364-1.76 2.168-3.108 1.8-1.346-.377-2.139-1.784-1.776-3.15.372-1.364 1.76-2.169 3.108-1.801z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgPaycellWithoutLabel;
